import Edit from "./Edit";

export default {
  edit: Edit,
};
